import Image from "next/image";
import { useState, useEffect } from "react";
import SignupButtonComponent from "components/koach/Shared/SignupButtonComponent";

const Sudoku = () => {
  return (
    <>
      <div className="bg-navy text-white flex flex-col items-center px-10">
        <div className="relative w-full">
          <div className="md:absolute top-0 left-0 p-10">
            <h1 className="text-4xl 2xl:text-5xl font-bold w-full text-center md:text-left text-landing-white">
              Klink
            </h1>
            <h2 className="text-3xl 2xl:text-4xl font-bold text-center md:text-left bg-gradient-to-r from-magenta to-landing-orange bg-clip-text text-transparent">
              Sudoku #1
            </h2>
          </div>

          <div className="flex justify-center">
            <img
              src="/sudoku/1.png"
              alt="Image"
              className="w-[100%] md:w-[50%] 2xl:w-[40%] h-auto md:pt-20"
            />
          </div>
        </div>

        <div className="py-10">
          <SignupButtonComponent />
        </div>
      </div>
    </>
  );
};

export default Sudoku;
